import { UPLOADS } from '../config/api';

/**
 * Resolve an image reference stored in the backend to a usable URL.
 * Accepts:
 * - A full Cloudinary URL (contains 'res.cloudinary.com') → returned as-is
 * - A full absolute URL (starts with http) → returned as-is
 * - A relative uploads path like '/uploads/filename.jpg' → joined with API base uploads URL
 * - A filename like 'abc.jpg' → UPLOADS/abc.jpg
 */
export default function getImageUrl(imageRef) {
  if (!imageRef) return '';

  try {
    if (typeof imageRef !== 'string') return '';
    const trimmed = imageRef.trim();
    if (!trimmed) return '';

    // If it's already a cloudinary URL or any absolute URL, return it
    if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) return trimmed;
    if (trimmed.includes('res.cloudinary.com')) return trimmed;

    // If it starts with /uploads, remove leading slash and join
    if (trimmed.startsWith('/uploads/')) {
      return `${UPLOADS}/${trimmed.replace(/^\/uploads\//, '')}`;
    }

    // If it looks like a filename, append to UPLOADS
    return `${UPLOADS}/${trimmed}`;
  } catch (e) {
    console.error('getImageUrl error', e);
    return '';
  }
}
